/** Valores, rótulos e endereços da Aplicação de Fontes Geradoras (#606), sem componente. */
import { montarEndereco, type PedidoDeEndereco } from '../../components/applications/enderecoDoAssistente';
import type { AvisoDosItensProps, ValorDeCampo } from '../../components/applications/tipos';
import { hojeEmSaoPaulo } from '../../utils/hojeEmSaoPaulo';
import { SourceExposureLevel, type SourceWithApplication } from '../../types/sourceApplication';

export interface ValoresDaFonte {
  exposureLevel: SourceExposureLevel;
  /** AAAA-MM-DD; vazio aplica sem data de início. */
  startDate: string;
}

export const ROTULO_DA_EXPOSICAO: Record<SourceExposureLevel, string> = {
  [SourceExposureLevel.LOW]: 'Baixo',
  [SourceExposureLevel.MEDIUM]: 'Médio',
  [SourceExposureLevel.HIGH]: 'Alto',
  [SourceExposureLevel.VERY_HIGH]: 'Muito Alto',
};

export const NIVEIS_DE_EXPOSICAO = Object.values(SourceExposureLevel);

/** O dia de hoje no fuso do servidor: em UTC, depois das 21h já seria amanhã e o servidor recusaria. */
export function hoje(): string {
  return hojeEmSaoPaulo();
}

/** A data como o campo de data a lê: só o dia, sem hora. */
export function diaDe(data: string | null | undefined): string {
  return data ? data.slice(0, 10) : '';
}

export function nomeDaAplicacao(aplicacao: SourceWithApplication): string {
  return aplicacao.sourceName || `Fonte ${aplicacao.sourceGeneratorId}`;
}

export function eExposicao(valor: ValorDeCampo): valor is SourceExposureLevel {
  return NIVEIS_DE_EXPOSICAO.some((nivel) => nivel === valor);
}

/** O mesmo destino na Aplicação de Riscos (D14). */
export function enderecoDosRiscos({ destino, empresaId }: AvisoDosItensProps): string {
  const ids: PedidoDeEndereco['ids'] = { company: empresaId, [destino.nivel]: destino.id };
  return montarEndereco('/risk-applications', { nivel: destino.nivel, ids });
}

/**
 * O que impede gravar um início completo na linha: o servidor recusa o futuro e o início depois
 * do fim. Nulo quando pode gravar.
 */
export function problemaDoInicio(inicio: string, fim: string): string | null {
  if (inicio > hoje()) return 'O início não pode ser depois de hoje.';
  if (fim !== '' && inicio > fim) return `O início não pode ser depois do fim (${fim.split('-').reverse().join('/')}).`;
  return null;
}

/** Data existente com ano a partir de 1900: o que o campo mostra a meio da digitação não passa. */
export function eInicioCompleto(texto: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(texto) || Number(texto.slice(0, 4)) < 1900) return false;
  const data = new Date(`${texto}T00:00:00Z`);
  return !Number.isNaN(data.getTime()) && data.toISOString().slice(0, 10) === texto;
}
